module.exports = __webpack_public_path__ + "img/2026-10-11d_1.b69f01a7.jpg";